import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import QuoteLink from './QuoteLink';

const { Link, Links } = deriveLinkComponents(QuoteLink, api.getQuote);

export { Link as QuoteLink, Links as QuoteLinks };
